module.exports = __webpack_public_path__ + "img/youshi1.e7813ed4.webp";